import Highlights from "./Highlights";

export default Highlights;
